import {Action} from "@ngrx/store";

export * from './user.action';
export * from './user-local-storage.action';
export * from './user-payment-methods.action';
export * from './website.action';
export * from './ten-web-product.action';
export * from './website-product.action';
export * from './performance.action';
export * from './security.action';
export * from './backup.action';
export * from './builder-templates.action';
export * from './backup-limits.action';
export * from './job.action';
export * from './user-summaries.action';
export * from './tour-section.action';
export * from './chat-overlay-section.action';
export * from './activity-notifications.action';
export * from './activities.action';
export * from './ongoing-activities.action';
export * from './ongoing-activity.action';
export * from './image-optimizer-history.action';
export * from './hosting-domains.action';
export * from './hosting-zones.action';
export * from './hosting-redirects.action';
export * from './hosting-logs.action';
export * from './hosting-resources.action';
export * from './hosting-visits.action';
export * from './hosting-info.action';
export * from './hosting-certificates.action';
export * from './hosting-cache-exclude.action';
export * from './hosting-settings.action';
export * from './hosting-php-configs.action';
export * from './website-tags.action';
export * from './knowledge-base.action';
export * from './workspace.action';
export * from './workspace-switcher.action';
export * from './website-sidebar.action';
export * from './ai-sidebar.action';
export * from './booster.action';
export * from './booster-data.action';
export * from './booster-advanced-settings.action';
export * from './ai-builder.action';
export * from './cloudflare-data.action';
export * from './cache-rules.action';
export * from './bandwidth.action';
export * from './troubleshoot.action';
export * from './image-optimizer.action';
export * from './ecommerce-products.action';
export * from './ecommerce-orders.action';
export * from './ecommerce-customers.action';
export * from './ecommerce-create-merchant.action';
export * from './ecommerce-payment-methods.action';
export * from './ecommerce-public-key.action';
export * from './ecommerce-analytics.action';
export * from './ecommerce-tax-classes.action';
export * from './ecommerce-refunds.action';
export * from './ecommerce-performance.action';
export * from './ecommerce-performance-now.action';
export * from './ecommerce-performance-report.action';
export * from './ecommerce-performance-report-last-year.action';
export * from './ecommerce-performance-net-sales.action';
export * from './ecommerce-performance-net-sales-last-year.action';
export * from './payments.action';
export * from './ecommerce-setup-list.action';
export * from './ecommerce-settings.action';
export * from './ecommerce-tax-settings.action';
export * from './ecommerce-tax-rates.action';
export * from './ecommerce-general-settings.action';
export * from './ecommerce-emails-list.action';
export * from './ecommerce-emails-settings.action';
export * from './ecommerce-navigation.action';
export * from './domains-portfolio.action';
export * from './domain-expanded-data.action';
export * from './backup-list.action';
export * from './backup-settings.action';
export * from './websites-zone.action';
export * from './10web-api.actions';
export * from './website-wp-version.action';
export * from './used-ai-credits.actions';
export * from './company-info.action';
export * from './vibe-files.action';
export * from './vibe-limitations.action';

export const INIT_STORE: string = '[store] Init Store';
export const FOO: string = '[store] Foo';

export class InitStore implements Action {

  readonly type: string = INIT_STORE;

}

export class Foo implements Action {

  readonly type: string = FOO;

}
